import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { hook } from '@g4/automation-hooks';

import { Box, Text } from './Boneyard';

import OVERNIGHT_ICON from '../images/overnight-icon.svg';

const propTypes = {
  label: PropTypes.string,
  automationHook: PropTypes.string,
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      common: PropTypes.shape({
        peacockBlue: PropTypes.string.isRequired,
      }),
    }),
  }),
};

const OvernightIcon = styled.img.attrs({
  src: OVERNIGHT_ICON,
  alt: '',
})`
  width: 10px;
  height: 10px;
  margin-right: 3px;

  ${props => props.theme.query.md} {
    width: 15px;
    height: 15px;
  }
`;

const OvernightBadge = ({ label = 'Next Day', automationHook, theme }) => (
  <Box d="flex" alignItems="center" {...hook(automationHook)}>
    <OvernightIcon />
    <Text color={theme.colors.common.peacockBlue} size={12}>
      {label}
    </Text>
  </Box>
);

OvernightBadge.propTypes = propTypes;

export default withTheme(OvernightBadge);
